import { GET_ADDRESS_BY_CATEGORY_SUCCESS, GET_ADDRESS_BY_CATEGORY_REQUEST, GET_ADDRESS_BY_CATEGORY_FAILURE, GET_ADDRESS_BY_CATEGORY_RESET } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getAddressByCategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ADDRESS_BY_CATEGORY_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_ADDRESS_BY_CATEGORY_REQUEST:
            return Object.assign({}, state);
        case GET_ADDRESS_BY_CATEGORY_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case GET_ADDRESS_BY_CATEGORY_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default getAddressByCategoryReducer;
